'use strict';

angular.module('far.models.campCountry', [])
    .service('campCountry', function ($log, $http) {
        var list = [],
            firstListQuery = true,
            listQueryProgress = false;

        Object.defineProperty(this, 'list', {
            get: function () {
                if (firstListQuery && !listQueryProgress) {
                    listQueryProgress = true;

                    $http.get(Routing.generate('api_get_camp_country'))
                        .then(function (response) {
                            response.data.forEach(function (item) {
                                list.push(item);
                            });

                            firstListQuery = false;
                            listQueryProgress = false;
                        })
                        .catch(function (response) {
                            $log.error(response);
                            listQueryProgress = false;
                        });
                }

                return list;
            }
        });
    });